<template>
<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg"></svg>
</template>

<script>
// TODO: Find and add SVG for Clever
// PNG available here: https://dev.clever.com/docs/identity-api#section-liwc-button-assets
export default {
  name: 'CleverIcon',
}
</script>



// WEBPACK FOOTER //
// CleverIconBlack.vue?434730c2